export default "__VITE_ASSET__5fc0fd7b__"